import React, { useEffect } from 'react';
import { useUsersContext } from '../contexts/users.tsx';

const Table = ({ columns, rows }) => {
  const { isLoggedIn } = useUsersContext();
  
  return (
    <table className="table">
      <thead>
        <tr>
          {/* Dynamically render column headers */}
          {columns.map((column, index) => (
            (column.name != 'delete' || isLoggedIn) &&
            <th key={index} scope="col">
              {column.header.toUpperCase()}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {/* Dynamically render rows */}
        {rows.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {columns.map((column, colIndex) => {
              const cellValue = row[column.name];
              return (
                <td key={colIndex}>
                  {column.cell ? (
                    column.cell({ row })
                  ) :
                    typeof cellValue === 'boolean' ? (
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={cellValue}
                          readOnly
                        />
                      </div>
                    ) :
                      column.name === 'delete' ? (
                        isLoggedIn &&
                        <button type="button" className="btn" onClick={() => { column.actionHandler({ row }) }}>
                          <i className="bi bi-trash3" />
                        </button>
                      ) :
                        cellValue}
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Table;
